import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { UIRouterModule } from '@uirouter/angular';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

/*
 * Platform and Environment providers/directives/pipes
 */
import { environment } from 'environments/environment';
import { APP_STATES } from './app.states';
import { configureRouterModule } from './router.config';
// App is our top level component
import { AppComponent } from './app.component';
import { APP_RESOLVER_PROVIDERS } from './app.resolver';
import { AppState, InternalStateType } from './app.service';
import { HomeComponent } from './home';
import { NoContentComponent } from './noContent/noContent.component';

import '../styles/styles.scss';
import '../styles/headings.css';
import { HomeModule } from './home/home.module';
import { GlobalModule } from './global/global.module';
import { CheckoutModule } from './checkout/checkout.module';
import { AuthModule } from './auth/auth.module';
import { ButtonsModule } from './buttons/buttons.module';
import { PagesModule } from './pages/pages.module';
import { CookieModule } from 'ngx-cookie';
import { MicrositesModule } from './microsites/microsites.module';

import { registerLocaleData } from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';

registerLocaleData(localeDe, 'de-DE', localeDeExtra);

// Application wide providers
const APP_PROVIDERS = [
  ...APP_RESOLVER_PROVIDERS,
  AppState
];

interface StoreType {
  state: InternalStateType;
  restoreInputValues: () => void;
  disposeOldHosts: () => void;
}

/**
 * `AppModule` is the main entry point into Angular2's bootstraping process
 */
@NgModule({
  bootstrap: [ AppComponent ],
  declarations: [
    AppComponent,
    NoContentComponent
  ],
  /**
   * Import Angular's modules.
   */
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    GlobalModule,
    CheckoutModule,
    AuthModule,
    ButtonsModule,
    PagesModule,
    MicrositesModule,
    HttpClientModule,
    CookieModule.forRoot(),
    UIRouterModule.forRoot({
      states: APP_STATES,
      // otherwise: { state: 'app', params: {} },
      useHash: false,
      config: configureRouterModule
    }),

    HomeModule
  ],
  /**
   * Expose our Services and Providers into Angular's dependency injection.
   */
  providers: [
    environment.ENV_PROVIDERS,
    APP_PROVIDERS
  ]
})
export class AppModule {}


// WEBPACK FOOTER //
// ./src/app/app.module.ts